import { Sparkles, TrendingUp, Wrench, ShieldCheck, Palette, Gauge, Plug, Scale, Smartphone, Zap } from "lucide-react";

// Catégories de notes de version (spec PROGÈRE) — icône, couleur (token thème), badge.
export const RELEASE_CATEGORIES = {
  new: { Icon: Sparkles, color: "var(--gold)", badge: "NOUVEAU", label: "Nouveauté" },
  improvement: { Icon: TrendingUp, color: "var(--pg-info)", badge: "AMÉLIORÉ", label: "Amélioration" },
  fix: { Icon: Wrench, color: "var(--green)", badge: "CORRIGÉ", label: "Correction" },
  security: { Icon: ShieldCheck, color: "var(--red)", badge: "SÉCURITÉ", label: "Sécurité" },
  design: { Icon: Palette, color: "var(--gold)", badge: "DESIGN", label: "Design" },
  performance: { Icon: Gauge, color: "var(--pg-info)", badge: "PERFORMANCE", label: "Performance" },
  integration: { Icon: Plug, color: "var(--green)", badge: "INTÉGRATION", label: "Intégration" },
  legal: { Icon: Scale, color: "var(--gold)", badge: "LÉGAL", label: "Légal" },
  mobile: { Icon: Smartphone, color: "var(--pg-info)", badge: "MOBILE", label: "Mobile" },
  automation: { Icon: Zap, color: "var(--pg-info)", badge: "AUTOMATISATION", label: "Automatisation" },
};

export const catMeta = (c) => RELEASE_CATEGORIES[c] || RELEASE_CATEGORIES.new;

// Items normalisés : accepte le nouveau format [{category,text}] ou l'ancien notes[].
export const releaseItems = (rel) => {
  if (rel?.items?.length) return rel.items;
  return (rel?.notes || []).map((t) => ({ category: "new", text: t }));
};
